module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "ch_03"
    }
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "page13"
    }
  })]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "bhead"
  }, [_c('span', [_vm._v("3")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("WO-THIRTY "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.,")]), _vm._v(" Caffery and Maddox stood silently staring off into the white-tiled autopsy suite: five aluminum dissecting stations, five bodies, unseamed from pubis to shoulders, skin peeled away like hides, revealing raw ribs marbled with fat and muscle. Juices leaked into the pans beneath them.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Caffery knew this well: the smell of disinfectant mingling with the unmistakable stench of viscera in the chill air. But five. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Five")]), _vm._v(". All tagged and dated the same day. He had never seen it on this scale. The morticians, moving silently in their peppermint-green galoshes and scrubs, didn’t appear to find this unusual. One smiled as she handed him a face mask.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Just one moment, gentlemen.” Harsha Krishnamurthi was at the farthest dissecting table. The corpse’s scalp had been peeled from the skull down to the squamous cleft of the nose, and folded over so the hair and face hung like a wet rubber mask, inside out, covering the mouth and neck, pooling on the clavicle. Krishnamurthi lifted the intestines out and slopped them into a stainless-steel bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Who’s running?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Me.” A small mortician in round glasses appeared at his side.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("“Good, Martin. Weigh them, run them, prepare samples. Paula, I’m finished here, you can close up. Don’t let the sutures overlap the wounds. Now, gentlemen.” He pushed aside the halogen light, lifted his plastic visor and turned to Maddox and Caffery, gloved, splattered hands held rigidly out in front. He was handsome, slim, in his fifties, the deep-polished wood-colored eyes")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v(" slightly wet with age, his gray beard carefully trimmed. “Grand tour, is it?”")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Maddox nodded. “Have we got a cause of death?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I think so. And if I’m right, a very interesting one too. I’ll come to that.” He pointed down the room. “Entomology’ll give you more—but I can give you approximates on all of them. The first one you found was the last one to die. Let’s call her number five. She died less than a week ago. Then we jump back almost a month, then another five weeks and then another month and a half. The first one probably died Decemberish but the gaps are getting closer. We’re lucky: not too much in the way of third-party artifacts—they’re pretty well preserved.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He pointed to a sad loose pile of blackened flesh on the second dissecting table.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The first to die. Long bones tell me she hadn’t even turned eighteen. There’s something that looks like a tattoo on her left arm. Might be the only way we can ID her. That or odontology. Now”—he held up a crooked finger—“appearance on arrival: I don’t know how much you saw in the field, but they were all wearing makeup. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Heavy")]), _vm._v(" makeup. Clearly visible. Even after they’ve been in the ground this long. Eye shadow, lipstick. The photographer has it all covered.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Makeup, tattoos—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yes, Mr. Maddox. And, thinking along those lines, two had pelvic infections, one a keratinized anus, plenty of evidence of drug use; endocarditis of the tricuspid valves. I don’t want to jump to conclusions—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yes, yes, yes,” Maddox muttered. “So we’re saying they’re toms. I think we already guessed that. What can you tell us about the mutilations?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Ah! Interesting.” Krishnamurthi edged in next to a cadaver, beckoning them to follow. Caffery thought, not for the first time, how like a side of hung meat the unskinned human body is. “You can see what I’ve done is to bring the second TA incision in tight, missing the one our offender did and avoiding the breasts so I could biopsy the incisions and get a look inside to see what’s going on in there.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“And?”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page14"
    }
  }), _c('a', {
    attrs: {
      "id": "page15"
    }
  })]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“Some tissue has been removed.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Maddox and Caffery exchanged glances.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yes. It’s roughly consistent with a standard beta mark breast reduction procedure. Stitched up, too. I suppose it’s significant that your offender hasn’t bothered with this decoration on the smaller-breasted victims.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Which ones?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Victims two and three. And let me show you something interesting.” He beckoned them to where a mortician was stitching up the crumpled torso he’d taken the intestines from. “The nail scrapings look dismal—and the very strange thing is I can’t find any signs of a struggle. Except on this one. On victim number three.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They gathered around the corpse. It was small, as small as a child, and Caffery knew that for this accidental resemblance, rational or not, she would be set aside in the team’s considerations.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“She weighed in at forty kilos, that’s not much more than six stone.” Reading Caffery’s mind, Krishnamurthi said, “But she wasn’t an adolescent. Just very petite. Perhaps that’s why the breasts were not mutilated.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The hair color . . . ?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Hair dye. Hair degrades very slowly. That aubergine color—it won’t have changed much since death. Now, look.” He pointed a wet black finger at a scattered pattern on the wrists. “It’s difficult to distinguish from the normal lesions of decomposition, but these are actually ligature marks. Antemortem. And a gag around here on the face. On the ankles too, chafing, bleeding. The others died as cool as ice; they just”—he held out his hand and mimed cresting a summit—“just "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tipped")]), _vm._v(" over the edge there. Like falling off a log. But this one—this one’s different.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Different?” Caffery looked up. “Why different?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“This one struggled, gentlemen. She fought for her life.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The others didn’t struggle?”")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("“No.” He held up his hands. “I’m coming to that. Just bear with me, okay?” He rolled aside a triple-beam balance and moved on to the congested, swollen body of the first victim discovered. “Now.” He looked up, waiting for Maddox and Caffery to follow. “Now, then. This we’ll call number five. Dreadful state, really. No doubt the head injury was postmortem, done by heavy machinery.")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v(" Your guess of the bulldozer sounds about right. Gives us big problems identifying her. Our best hope’s prints, although there again we encounter problems.” He lifted up a hand and gently pushed the skin back and forward. It moved, jellied and thick, like the skin on a pudding.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“See that slippage? Not a hope in hell of getting a straight dead set. What I’ll have to do is flip the skin off and print.” He lowered the hand. “She was a user, but her death was instantaneous, not an OD, none of the usual esophageal and tracheal artifacts, no pulmonary edema.” He rolled the body gently onto its side and pointed to a greenish collection on the buttocks. “Most of what you’re seeing is putrefaction. But under it you can see black blood pricks?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He rolled the body back. “Scattered hypostasis. She was moved after death. There’s more on her arms—even, rather unusually, in her ankles.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Unusually?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You’d see that in a hanging victim. Blood drifts downward into the feet and ankles.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Caffery frowned. “You said the hyoid’s intact.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It is. And from what’s left of the neck I can guarantee this was not a hanging.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Well?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“She was in a standing position for some time. Postmortem.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Standing?")]), _vm._v("” Caffery said. “Standing?” The image made him uneasy. He turned to Maddox, expecting explanation—an easy reassurance. But it wasn’t there. Instead Maddox narrowed his eyes and shook his head. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I don’t know")]), _vm._v(", he was saying. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Don’t look at me for every answer")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Maybe she was propped up,” Krishnamurthi continued. “I can’t see any whitish areas to indicate how—the putrefaction is too advanced—but she might have been suspended under her arms, or wedged somewhere so she was upright. Some time soon after death, when the blood was not yet viscid.” He paused. “Mmmm-hm. I missed that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What is it?”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('a', {
    attrs: {
      "id": "page17"
    }
  })]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("He bent in and gently tweezered something from the scalp. “Good.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“A hair.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Caffery leaned in. “A pubic hair?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Maybe.” Krishnamurthi held it to the light. “No. That’s a head hair. Negroid. It won’t be any use for DNA except mitochondrial, there’s not enough follicle on it.” He carefully bagged the hair and handed it to the mortician for labeling. “I’ve already pulled some blond hairs off three of the victims. They’re on their way to Lambeth.” He moved to the next table. “Number two. She died fourteen or fifteen weeks ago. Five eight, age maybe thirty. The fingers are desiccated, but we’ll still get a good dead set; there’s an excellent chelation tissue builder on the market. Gelatin. Swells the tips up. Normally for that we’d take the hands off and do it at Lambeth, but”—he leaned in to Maddox—“since the fuss over the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Marchioness")]), _vm._v(" I’ve stopped taking hands off. Do it right here in the pit, awkward or not.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He moved on to the next table, where a large white carcass lay, cracked down the center and unfurled. A cobwebbing of silvery white fascia shimmered between the blue ribs. The bleached blond hair had been wetted and smoothed back off the clean forehead. The throat, too, was split wide, revealing a glimpse of a milky cord. “Victim four, gentlemen.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Caffery lightly touched the ankle. “Good.” A tattoo, surprisingly clear, centimeters above the tarsal bone. Bugs Bunny. Trademark green-topped carrot.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You say no OD artifacts?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“That’s correct. No trauma either.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“So how did they die?”")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("Krishnamurthi held up a stained finger and smiled slowly. “That’s where I’ve got an idea. Look at this.” He gently inserted his fingers into the neck cavity, carefully opening the throat wider, inching aside the trachea and esophagus, until the spinal column showed slippery and gray. “This man is so clever, but not as clever as I am. If you drain off enough cerebrospinal fluid from down here”—he straightened and tapped his lower back—“instant")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v(" death, hardly a mark. Even your standard lumbar puncture has to be done very, very carefully; take too much of that stuff and whoopee, your patient hits the deck. Now, these subjects’ve got about the right amount of CSF in the spine and no puncture wounds on the back. So I’m wondering if he cut out the middleman and went direct”—he nudged the calibrated scalpel in the opening between the vertebrae and carefully excised a small amount of the white myelin caul—“to the brain stem itself.”")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“The brain stem?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“That’s right.” Krishnamurthi made a second incision and bent in to look. “Hmmmm.” He carefully manipulated the scalpel and muttered to himself. “No, I’m incorrect.” He frowned and looked up. “This wasn’t done by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("removing")]), _vm._v(" CSF.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No. But there "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("has")]), _vm._v(" been something invasive here. You see, Superintendent Maddox, the brain stem is a very delicate structure. You would only have to get a needle in the medulla oblongata, wiggle it about, and every physiological function would crash to a halt—just as we’re seeing with these subjects.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Instant death.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Exactly. Now, I’m not seeing the extensive damage you’d expect with that, but it doesn’t mean something wasn’t "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("injected")]), _vm._v(" in there. It wouldn’t have mattered what—even water could do it. Subject’s heart and lungs would have simply stopped. Instantly.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“And you say that except for number three none of them struggled?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“That’s what I said.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Then how?” Caffery rubbed his temples lightly. “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("How")]), _vm._v(" did he keep them still?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“My guess is once you get stomach, blood and deep-tissue analysis back from toxicology you’ll find something had them tranquilized.” He cocked his head. “One would have to assume they were semiconscious when that needle went in.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Right.” Caffery folded his arms and tilted back on his heels. “Lambeth needs to test for alcohol, Rohypnol, barbs, mazis. And those—” He nodded to a victim’s forehead. About a centimeter below the hairline he could make out a horizontal line of faint ocher marks. “Those things on her head.”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page18"
    }
  }), _c('a', {
    attrs: {
      "id": "page19"
    }
  })]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yes, odd, aren’t they?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“They all have them?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“All except number four. They extend all the way around the head. Almost a perfect circle. And they’ve a very distinctive pattern: a few dots, then a slash.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Caffery bent a little closer. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dot dot dash. Someone’s joke?")]), _vm._v(" “How were they made?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No idea—I’ll work on it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“How about this suture material?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yes.” Krishnamurthi was silent for a moment. “It’s professional.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Caffery straightened up. Maddox was looking at him with clear gray eyes over his mask. Caffery raised his eyebrows. “Now, isn’t "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" interesting?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I didn’t say the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("technique")]), _vm._v(" was professional, gentlemen.” Krishnamurthi peeled off his gloves, tipped them into a yellow biohazard bin and crossed to a sink. “Just the material. It’s silk. But the incision didn’t extend to the xiphoid process. Pretty crude. The beta breast incision, that’s the classic surgery technique taught in med school.” He picked up the yellow bar of reen soap and lathered his arms. “He’s taken the fat from almost the right place, and the incision is very clean, done with a scalpel. But the stitching—not professional. Not professional at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“But if I guessed our offender had a grasp on the rudiments, you’d say—?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I’d say you had a point. A good point. He was able to find the brain stem, which is remarkable.” He rinsed his hands and pulled off the visor. “Well. Do you want to see what he did before he sewed them back up?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“This way.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Drying his hands, he led them into an anteroom where the small mortician was chewing gum and cleaning the intestines at a porcelain scrub sink: holding them under a tap and rinsing the contents into a bowl. He carefully inspected the inner and outer linings, checking for corrosion. When he saw Krishnamurthi he laid the intestines to one side and rinsed his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Show them what we found inside the chest cavities, Martin.”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page19"
    }
  }), _c('a', {
    attrs: {
      "id": "page20"
    }
  })]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“Sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He tucked the gum in his cheek and picked up a large stainless-steel bowl covered in a square of brown paper. He removed the paper and held the bowl out.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Maddox bent in and jerked his head back as if he’d been slapped. “Jesus.” He turned away, pulling a clean, monogrammed handkerchief from his suit pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Show me?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Sure.” The assistant held the bowl out and Caffery gingerly peered over the edge.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("In the stinking stew at the bottom of the blood-spattered bowl, five tiny dead shapes huddled together as if trying to keep warm. He looked up at the mortician. “Are they what I think they are?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The mortician nodded. “Oh yes. They’re what they appear to be.”")])])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-982379f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch_03.vue
// module id = 84
// module chunks = 0